class WorkbookGeneralSettings {
    workbookTabsPosition: KnockoutObservable<string>;
    drawerWorkbookSideBars: DevExpress.ui.dxDrawer;
    editing: KnockoutObservable<boolean>;

    constructor() {
        this.workbookTabsPosition = ko.observable("bottom");
        this.editing = ko.observable(false);
    }

    onEditingChanged() {
        workbook.workbookConfig.workbookHelper.showHideFilterActions(workbook.workbookConfig.generalSettings.editing());
        if (workbook.workbookConfig.generalSettings.editing()) {
            workbook.workbookConfig.collapseWidgets();
        }

        if (!workbook.workbookConfig.generalSettings.editing() && workbook.workbookConfig.activeTab()?.tabConfig?.hiddenTab()) {
            let idx = workbook.workbookConfig.workbookHelper.workbookTabsDataSource().findIndex(x => !x.tab().tabConfig.hiddenTab());
            workbook.workbookConfig.workbookHelper.workbookTabsSelectedIndex(idx < 0 ? 0 : idx);
        }
        workbook.workbookConfig.activeTab().configureResizableDraggable();

        //force a resize because the navigation buttons are disabled when changing the visibility of the tabs
        workbook.workbookConfig.workbookHelper.workbookTabsPanelResize?.();

        let o = {
            url: urlConfigs.tabs + "UpdateWorkbookSettings",
            data: {
                workbookId: workbook.workbookConfig.workbookId(),
                editing: workbook.workbookConfig.generalSettings.editing(),
            },
            dataType: "json",
            async: false
        } as RequestServerParams;
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = "Failed to update workbook settings";
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);
    }
}